const HalfStar = () => (
	<svg
		width='16'
		height='16'
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<g clipPath='url(#clip0_81_1417)'>
			<path
				d='M7.14486 0.86206L5.19196 4.82168L0.822626 5.45869C0.0390758 5.57233 -0.274942 6.53831 0.293281 7.09158L3.4544 10.1719L2.70673 14.5233C2.57216 15.3099 3.40057 15.899 4.0944 15.5312L8.00317 13.4766L11.912 15.5312C12.6058 15.896 13.4342 15.3099 13.2996 14.5233L12.552 10.1719L15.7131 7.09158C16.2813 6.53831 15.9673 5.57233 15.1837 5.45869L10.8144 4.82168L8.86149 0.86206C8.51159 0.156267 7.49775 0.147295 7.14486 0.86206Z'
				fill='url(#halfStarGradient)'
				stroke='#DFB158'
			/>
		</g>
		<defs>
			<clipPath id='clip0_81_1417'>
				<rect width='16' height='16' fill='white' />
			</clipPath>
			<linearGradient
				id='halfStarGradient'
				x1='0'
				y1='0'
				x2='16'
				y2='0'
				gradientUnits='userSpaceOnUse'
			>
				<stop offset='50%' stopColor='#DFB158' />
				<stop offset='50%' stopColor='transparent' />
				<stop offset='100%' stopColor='transparent' />
			</linearGradient>
		</defs>
	</svg>
);

const FilledStar = () => (
	<svg
		width='16'
		height='16'
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<g clip-path='url(#clip0_81_1417)'>
			<path
				d='M7.14486 0.86206L5.19196 4.82168L0.822626 5.45869C0.0390758 5.57233 -0.274942 6.53831 0.293281 7.09158L3.4544 10.1719L2.70673 14.5233C2.57216 15.3099 3.40057 15.899 4.0944 15.5312L8.00317 13.4766L11.912 15.5312C12.6058 15.896 13.4342 15.3099 13.2996 14.5233L12.552 10.1719L15.7131 7.09158C16.2813 6.53831 15.9673 5.57233 15.1837 5.45869L10.8144 4.82168L8.86149 0.86206C8.51159 0.156267 7.49775 0.147295 7.14486 0.86206Z'
				fill='#DFB158'
			/>
		</g>
		<defs>
			<clipPath id='clip0_81_1417'>
				<rect width='16' height='16' fill='white' />
			</clipPath>
		</defs>
	</svg>
);

const EmptyStar = () => (
	<svg
		width='16'
		height='16'
		viewBox='0 0 16 16'
		fill='none'
		xmlns='http://www.w3.org/2000/svg'
	>
		<g clip-path='url(#clip0_81_1417)'>
			<path
				d='M7.14486 0.86206L5.19196 4.82168L0.822626 5.45869C0.0390758 5.57233 -0.274942 6.53831 0.293281 7.09158L3.4544 10.1719L2.70673 14.5233C2.57216 15.3099 3.40057 15.899 4.0944 15.5312L8.00317 13.4766L11.912 15.5312C12.6058 15.896 13.4342 15.3099 13.2996 14.5233L12.552 10.1719L15.7131 7.09158C16.2813 6.53831 15.9673 5.57233 15.1837 5.45869L10.8144 4.82168L8.86149 0.86206C8.51159 0.156267 7.49775 0.147295 7.14486 0.86206Z'
				fill='transparent'
				stroke='#DFB158'
			/>
		</g>
		<defs>
			<clipPath id='clip0_81_1417'>
				<rect width='16' height='16' fill='white' />
			</clipPath>
		</defs>
	</svg>
);

const Rating = ({ ratingValue }) => {
	if (
		isNaN(ratingValue) ||
		ratingValue === undefined ||
		ratingValue < 0 ||
		ratingValue > 5
	) {
		console.error('Invalid rating:', ratingValue);
		return [];
	}

	const totalStars = 5;
	const stars = [];
	const fullStars = Math.floor(ratingValue);
	const fractionalPart = Math.round((ratingValue - fullStars) * 10) / 10;

	for (let i = 0; i < fullStars; i++) {
		stars.push(<FilledStar />);
	}

	if (fractionalPart >= 0.1 && fractionalPart <= 0.5) {
		stars.push(<HalfStar />);
	} else if (fractionalPart > 0.5 && fractionalPart < 1) {
		stars.push(<FilledStar />);
	}

	const remainingStars = totalStars - stars.length;
	for (let i = 0; i < remainingStars; i++) {
		stars.push(<EmptyStar />);
	}

	return stars;
};

export default Rating;
